var map = {
	"./books/aides/Racism_Diagram.png": [
		"2fce",
		7,
		"chunk-2d0be6cc"
	],
	"./books/badscience.md": [
		"a7a0",
		9,
		"chunk-7fde9a0a"
	],
	"./books/coloroflaw.md": [
		"6b9b",
		9,
		"chunk-1bf66fca"
	],
	"./books/comingsoon.md": [
		"270c",
		9,
		"chunk-7e440917"
	],
	"./books/covers/badscience.jpg": [
		"e4f3",
		7,
		"chunk-2d225a32"
	],
	"./books/covers/coloroflaw.jpg": [
		"fa76",
		7,
		"chunk-2d2371d0"
	],
	"./books/covers/prisonersofgeography.png": [
		"1459",
		7,
		"chunk-2d0ab0fd"
	],
	"./books/covers/therighteousmind.png": [
		"a66c",
		7,
		"chunk-2d208a98"
	],
	"./books/covers/winnerstakeall.png": [
		"9e76",
		7,
		"chunk-2d0f0c21"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[2]).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "bf10";
module.exports = webpackAsyncContext;